"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _BrightSignMetricsProvider = _interopRequireDefault(require("./providers/brightsign/BrightSignMetricsProvider"));
var _DeviceType = _interopRequireDefault(require("./DeviceType"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class DeviceMetricsProviderFactory {
  static create(deviceType) {
    switch (deviceType) {
      case _DeviceType.default.BRIGHTSIGN:
        return new _BrightSignMetricsProvider.default();
      default:
        console.warn(`No DeviceMetricsProvider implemented for device type: "${deviceType}". Device metrics will not be collected.`);
        return null;
    }
  }
}
var _default = exports.default = DeviceMetricsProviderFactory;